/**
 * Skeleton Loader Manager
 * Handles showing and hiding skeleton loading screen for page loads
 */

class SkeletonLoader {
  constructor() {
    this.skeletonLoader = null;
    this.hideTimeout = null;
    this.initialized = false;
  }

  /**
   * Initialize the skeleton loader
   */
  init() {
    if (this.initialized) return;
    
    this.skeletonLoader = document.querySelector('.skeleton-loader');
    if (!this.skeletonLoader) return;

    this.initialized = true;

    // Hide skeleton when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.hide());
    } else {
      // If DOM is already loaded, hide immediately
      this.hide();
    }

    // Also hide on window load to be safe
    window.addEventListener('load', () => this.hide());

    // Listen for Shopify section updates
    document.addEventListener('shopify:section:load', () => this.resetLoader());
    document.addEventListener('shopify:section:reorder', () => this.resetLoader());
    document.addEventListener('shopify:section:deselect', () => this.resetLoader());

    // Handle page transitions (if using AJAX or turbo)
    document.addEventListener('page:loading', () => this.show());
    document.addEventListener('page:loaded', () => this.hide());
  }

  /**
   * Show the skeleton loader
   */
  show() {
    if (!this.skeletonLoader) return;

    clearTimeout(this.hideTimeout);
    this.skeletonLoader.classList.remove('hide', 'hidden');
    
    // Force reflow
    void this.skeletonLoader.offsetHeight;
  }

  /**
   * Hide the skeleton loader with fade-out effect
   */
  hide() {
    if (!this.skeletonLoader) return;

    // Clear any pending hide timeouts
    clearTimeout(this.hideTimeout);

    // Add hide class for fade-out
    this.skeletonLoader.classList.add('hide');

    // Remove from DOM after transition completes
    this.hideTimeout = setTimeout(() => {
      if (this.skeletonLoader) {
        this.skeletonLoader.classList.add('hidden');
      }
    }, 300);
  }

  /**
   * Reset loader for section changes
   */
  resetLoader() {
    // Only show if needed
    const mainContent = document.querySelector('#MainContent');
    if (mainContent && !mainContent.querySelector('[data-loaded]')) {
      this.show();
      // Auto-hide after delay if content becomes available
      setTimeout(() => this.hide(), 1000);
    }
  }

  /**
   * Manually control skeleton visibility
   */
  toggle(show = true) {
    if (show) {
      this.show();
    } else {
      this.hide();
    }
  }
}

// Initialize skeleton loader when script loads
const skeletonLoader = new SkeletonLoader();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => skeletonLoader.init());
} else {
  skeletonLoader.init();
}

// Export for global access
window.SkeletonLoader = skeletonLoader;
